"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RadioBase = ({
  disabled,
  name,
  label,
  value,
  checked,
  onChange
}) => {
  return _react.default.createElement(_FormControlLabel.default, {
    control: _react.default.createElement(_Radio.default, {
      disabled: disabled,
      color: "primary",
      name: name,
      checked: checked,
      value: value,
      onChange: onChange,
      value: value
    }),
    label: label
  });
};

var _default = RadioBase;
exports.default = _default;
module.exports = exports.default;